/* Source links open the single native drawer before navigating to their topic. */
(() => {
  const section = document.getElementById('difference');
  if (!section) return;
  const openEvidence = (hash, focus) => {
    if (!hash || !hash.startsWith('#pb-evidence-')) return;
    const target = document.getElementById(hash.slice(1));
    if (!target || !section.contains(target)) return;
    const drawer = target.tagName === 'DETAILS' ? target : target.closest('details');
    if (!drawer || !section.contains(drawer)) return;
    drawer.open = true;
    if (focus) {
      const focusTarget = target === drawer ? drawer.querySelector('summary') : target;
      focusTarget?.focus({ preventScroll: true });
    }
  };
  section.addEventListener('click', (event) => {
    const link = event.target.closest('a[href^="#pb-evidence-"]');
    if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    openEvidence(link.getAttribute('href'), true);
  });
  window.addEventListener('hashchange', () => openEvidence(window.location.hash, false));
  openEvidence(window.location.hash, false);
})();
